import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http'
import { NgxMaskConfig, NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask } from 'ngx-mask'
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule, inject, provideAppInitializer } from '@angular/core'
import { NavigationModule } from '@modules/navigation/navigation.module'
import { HeaderInterceptor } from '@interceptors/header.interceptor'
import { ClientInterceptor } from '@interceptors/client.interceptor'
import { CommonModule, registerLocaleData } from '@angular/common'
import { ErrorInterceptor } from '@interceptors/error.interceptor'
import { RetryInterceptor } from '@interceptors/retry.interceptor'
import { JwtInterceptor } from '@interceptors/jwt.interceptor'
import { AppCommonModule } from '@common/app-common.module'
import { AppRoutingModule } from '@app/app-routing.module'
import { BrowserModule } from '@angular/platform-browser'
import { ToastrModule, GlobalConfig } from 'ngx-toastr'
import { ReactiveFormsModule } from '@angular/forms'
import { AppComponent } from '@app/app.component'
import ptBr from '@angular/common/locales/pt'
import 'moment/locale/pt-br'
import { SessionMessagePartialModule } from '@app/management/planning/session-message-partial.module'
import { NoticeSessionChatFloatingHostComponent } from '@app/management/planning/chat/notice-session-chat-floating-host.component'
import { NativeAppLockComponent } from '@components/native-app-lock/native-app-lock.component'

import { NgSelectModule } from '@ng-select/ng-select'
import moment from 'moment/moment'
import { AuthService } from '@services/auth.service'

registerLocaleData(ptBr)

const maskConfig: Partial<NgxMaskConfig> = {
	validation: false
}

export const toastConfig = {
	autoDismiss: true,
	preventDuplicates: true,
	closeButton: true,
	enableHtml: true,
	progressAnimation: 'decreasing',
	progressBar: true,
	timeOut: 20000,
	extendedTimeOut: 10000,
	resetTimeoutOnDuplicate: true
} as GlobalConfig

const initAuthSession = (authService: AuthService) => () => authService.bootstrapSession()

@NgModule({
	declarations: [AppComponent, NoticeSessionChatFloatingHostComponent],
	bootstrap: [AppComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [
		CommonModule,
		BrowserModule,
		NativeAppLockComponent,
		NgSelectModule,
		AppRoutingModule,
		NgxMaskDirective,
		ReactiveFormsModule,
		SessionMessagePartialModule,
		AppCommonModule.forRoot(),
		NavigationModule.forRoot(),
		ToastrModule.forRoot(toastConfig)
	],
	providers: [
		NgxMaskPipe,
		provideEnvironmentNgxMask(maskConfig),
		{ provide: LOCALE_ID, useValue: 'pt' },
		{ provide: 'window', useValue: window },
		provideAppInitializer(() => {
			const initializerFn = initAuthSession(inject(AuthService))
			return initializerFn()
		}),
		// Consolidado numa única chamada (eram duas provideHttpClient() separadas) como parte da
		// revisão pedida pelo passo Angular 21 — a partir desta major o HttpClient passa a se
		// auto-prover no injector root por padrão, e duas chamadas separadas era um ponto de atenção
		// registrado no plan.md (specs/014-upgrade-angular-18-20). Nenhum interceptor está registrado
		// via HTTP_INTERCEPTORS (`grep -rn HTTP_INTERCEPTORS src/` não encontra nada) — withInterceptorsFromDi()
		// mantido por segurança, caso surja um no futuro, mas hoje é só withInterceptors() que importa.
		provideHttpClient(withInterceptorsFromDi(), withInterceptors([RetryInterceptor, ErrorInterceptor, ClientInterceptor, JwtInterceptor, HeaderInterceptor]))
	]
})
export class AppModule {
	constructor() {
		moment.locale('pt-br')
	}
}
